<template>
	<div className="group17 flex-col">
		<!--		<div className="section5 flex-col">-->
		<!--			<div className="bd11">-->
		<!--				<span className="word15">待缴费车辆</span>-->
		<!--			</div>-->
		<!--		</div>-->
		<!--	入口未放行	-->
		<div class="box">
			<div className="section8 flex-col">
				<span className="word15">入口未放行</span>
				<div class="scroll">
					<div className="wrap1 flex-row" v-for="(item, index) in showList0" :key="item.id"
						 @click="onTab(0,index)"
						 :style="{background: index === tabIndex0 ? '#3A394F' : ''}">
						<div class="tabItem">
							<div>{{ item.inCheckPointName }}</div>
						</div>
						<img src="../../assets/image/close.png"
							 :style="{width: '16px',height: '16px',margin: '0px 0px 1px 5px'}" alt=""
							 @click="closeNumberPlate(0,item)"/>
					</div>
				</div>
			</div>
			<div v-if="showList0.length" class="box-right">
				<span className="word17">{{ showList0[tabIndex0].numberPlate }}</span>
				<div className="section7 flex-col">
					<span className="word18">{{ getNameByFlagKey(showList0[tabIndex0].carType) }}</span>
				</div>
				<span className="txt4">备注信息：{{ showList0[tabIndex0].remarks || "暂无" }}</span>
				<span className="word24">入场时间：{{ getTimeFormat(Number(showList0[tabIndex0].inTime)) }}</span>
				<el-form class="infoIn" label-width="70px">
					<el-form-item label="备注信息">
						<el-input type="textarea" v-model="remark" autofocus placeholder="备注信息"/>
					</el-form-item>
				</el-form>
				<el-button type="primary" @click="openDoorManual">手动放行</el-button>
			</div>
		</div>
		<!--	待缴费车辆	-->
		<div class="box">
			<div className="section8 flex-col">
				<span className="word15">待缴费车辆</span>
				<div class="scroll">
					<div className="wrap1 flex-row" v-for="(item, index) in showList" :key="item.id"
						 @click="onTab(1,index)"
						 :style="{background: index === tabIndex ? '#3A394F' : ''}">
						<div class="tabItem">
							<div>{{ item.outCheckPointName }}</div>
						</div>
						<img src="../../assets/image/close.png"
							 :style="{width: '16px',height: '16px',margin: '0px 0px 1px 5px'}" alt=""
							 @click="closeNumberPlate(1,item)"/>
					</div>
				</div>
			</div>
			<div v-if="showList.length" class="box-right">
				<span className="word17">{{ showList[tabIndex].numberPlate }}</span>
				<div className="section7 flex-col">
					<span className="word18">{{ getNameByFlagKey(showList[tabIndex].carType) }}</span>
				</div>
				<div style="display: flex" v-if="showList[tabIndex].ymOrder">
					<div className="word19">总应收款:¥{{ showList[tabIndex].ymOrder.amountsPayable }}</div>
					<!-- <span className="word19" v-else>总应收款:¥{{
						showList[tabIndex].ymOrder.amountsPayable - showList[tabIndex].cfCouponList[0].denomination
					  }}</span> -->
					<el-popover placement="top" width="160" v-model:visible="visibleShow">
						<p>请输入优惠金额</p>
						<el-input placeholder="请输入" type="Number" style="margin-top: 5px"
								  v-model="modifiedAmount"></el-input>
						<div style="text-align: right; margin: 6px 0 0 0">
							<el-button size="mini" type="text" @click="visibleShow = false">取消</el-button>
							<el-button type="primary" size="mini" :disabled="!modifiedAmount"
									   @click="confirmChangeAmount">确定
							</el-button>
						</div>
						<template #reference>
							<el-button type="danger" icon="el-icon-edit" size="mini" circle
									   style="margin-left: 6px; width: 40px; height: 40px"></el-button>
						</template>
					</el-popover>
				</div>
				<div style="display: flex">
					<div className="word19" style="display: block;" v-if="showList[tabIndex]?.discountedPrice != null">
						优惠金额:¥{{ showList[tabIndex].discountedPrice }}
					</div>
				</div>
				<span className="word20">
					{{ getParkingTime(Number(showList[tabIndex].inTime), Number(showList[tabIndex].outTime)) }}
				</span>
				<span className="txt4">备注信息：{{ showList[tabIndex].remarks || "暂无" }}</span>
				<span className="word24">入场时间：{{ getTimeFormat(Number(showList[tabIndex].inTime)) }}</span>
				<span className="txt6">出场时间：{{ getTimeFormat(Number(showList[tabIndex].outTime)) }}</span>
				<div style="display: flex;justify-content: space-evenly;width: 100%;margin-top: 30px;">
					<div class="section9 flex-col" @click="openDoor('toll')" v-if="showList[tabIndex].ymOrder">
						<div class="info11">收费放行</div>
					</div>
					<div class="section10 flex-col" @click="onAbnormalRelease">
						<div class="info12">异常放行</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<el-dialog title="选择异常原因" v-model="openDoorDialogVisible" :modal-append-to-body="false" width="30%" center>
		<div class="Box">
			<div v-for="(item, index) of reason" :key="index"
				 :class="index === reasonIndex ? 'reasonBox_ac' : 'reasonBox'"
				 @click="onReason(index)">
				{{ item }}
			</div>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button type="danger" @click="openDoor('abnormal')" :disabled="reasonIndex === ''">确 定</el-button>
			</div>
		</template>
	</el-dialog>
</template>
<script>
import {mapGetters, mapState} from "vuex";
import {toRaw} from "vue";
import {$getParkingTime, $timeFormat} from "../../utils/index";
import {oneClickRelease, enterCarRemark} from "@/network/api";
import {cloneDeep} from "lodash";
import {ElMessage, ElMessageBox} from "element-plus";
import dayjs from "dayjs";

export default {
	emits: ["countPayAmountByDuty"],
	data() {
		return {
			visibleShow: false,
			modifiedAmount: "",
			list: [], list0: [],
			tabIndex0: 0, tabIndex: 0,
			openDoorDialogVisible: false,
			reason: ["特殊车辆", "系统故障", "业主拒绝缴费", "其他原因", "倒车误拍"],
			reasonIndex: "",
			showList: [], showList0: [],
			remark: ''
		};
	},
	created() {
		if (localStorage.getItem("ChargeLocalList")) {
			this.list = JSON.parse(localStorage.getItem("ChargeLocalList"));
			this.tabIndex = 0;
			// 获取所有的车辆类型
			this.$store.dispatch("getAllCarType");
		}
		if (localStorage.getItem("notEnteredList")) {
			this.list0 = JSON.parse(localStorage.getItem("notEnteredList"));
			this.tabIndex0 = 0;
			// 获取所有的车辆类型
			this.$store.dispatch("getAllCarType");
		}
	},
	computed: {
		...mapState([
			"chargeCar",
			"notEntered",
			"paidCar",
			"globalConfig",
			"carParkIndex",
			"carTypeList",
		]),
		...mapGetters(["carParkId"]),
	},
	watch: {
		chargeCar(value) {
			this.processingData(toRaw(value));
		},
		notEntered(value) {
			this.processNotEnter(toRaw(value));
		},
		// 监听已支付的车辆
		paidCar(value) {
			this.setPaidCar(toRaw(value));
		},
		carParkIndex() {
			this.showList0 = this.list0.filter((i) => i.carParkId === this.carParkId);
			this.showList = this.list.filter((i) => i.carParkId === this.carParkId);
		},
		list: {
			deep: true,
			handler(value) {
				this.showList = value.filter((i) => i.carParkId === this.carParkId);
			},
		},
		list0: {
			deep: true,
			handler(value) {
				this.showList0 = value.filter((i) => i.carParkId === this.carParkId);
			},
		},
	},
	methods: {
		getNameByFlagKey(flagKey) {
			const arr = this.carTypeList
			const foundItem = arr.find((item) => item.typeCode === +flagKey);
			return foundItem ? foundItem.name : null;
		},
		// 点击修改金额
		async confirmChangeAmount() {
			const {modifiedAmount, tabIndex, showList} = this;
			const info = showList[tabIndex];
			const amountsPayable = parseFloat(info.ymOrder.amountsPayable);
			if (modifiedAmount > amountsPayable) {
				this.$message({message: "不能大于等于总应付金额", type: "error"});
				return;
			}
			info.discountedPrice = modifiedAmount;
			showList[tabIndex] = info;
			localStorage.setItem("ChargeLocalList", JSON.stringify(showList));
		},
		// 点击关闭车牌
		closeNumberPlate(tabI, {numberPlate, id}) {
			ElMessageBox.confirm(`确定删除${numberPlate}吗？`, "提示", {
				confirmButtonText: "确认", cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				if (tabI === 0) {
					this.list0 = this.list0.filter(v => v.id !== id);
					window.localStorage.setItem("notEnteredList", JSON.stringify(this.list0));
					this.tabIndex0 = 0;
				} else {
					this.list = this.list.filter(v => v.id !== id);
					window.localStorage.setItem("ChargeLocalList", JSON.stringify(this.list));
					this.tabIndex = 0;
				}
			});
		},
		// 修改已支付车辆数据
		setPaidCar(value) {
			const numberPlate = value.numberPlate;
			const cloneList = cloneDeep(this.list);
			// 将这个车牌在列表中删除
			this.list = cloneList.filter((i) => i.numberPlate !== numberPlate);
			localStorage.setItem("ChargeLocalList", JSON.stringify(this.list));
			this.tabIndex = 0;

			if (this.globalConfig.promptPayCar) {
				ElMessage({
					message: `${numberPlate}已支付成功`,
					type: "success",
				});
			}
		},
		onReason(index) {
			this.reasonIndex = index;
		},
		getParkingTime(inTime, outTime) {
			return $getParkingTime(inTime, outTime);
		},
		getTimeFormat(time) {
			return $timeFormat(time, "YYYY-MM-DD HH:mm:ss");
		},
		// 检测来了新的收费车辆
		processingData(data) {
			if (this.list.length > 60) {
				this.list = this.list.slice(0, 60);
			}
			const list = cloneDeep(this.list);
			const {outCheckPointId} = data;
			this.list = list.filter(v => v.outCheckPointId !== outCheckPointId);
			this.list.push(data);
			localStorage.setItem("ChargeLocalList", JSON.stringify(this.list));
		},
		processNotEnter(data) {
			if (this.list0.length > 60) {
				this.list0 = this.list0.slice(0, 60);
			}
			const list = cloneDeep(this.list0);
			const {inCheckPointId} = data;
			this.list0 = list.filter(v => v.inCheckPointId !== inCheckPointId);
			this.list0.push(data);
			localStorage.setItem("notEnteredList", JSON.stringify(this.list0));
		},
		onTab(type, index) {
			if (type === 0) {
				this.tabIndex0 = index;
			} else this.tabIndex = index;
		},
		// 点击了异常放行
		onAbnormalRelease() {
			this.openDoorDialogVisible = true;
		},
		async openDoor(type) {
			let info = this.list[this.tabIndex];
			// 收费放行
			if (type === "toll") {
				// ElMessageBox.confirm(`${info.cfCarParkUseLog.numberPlate}出场收费${info.ymOrder.amountsPayable}元`, '提示',
				//     {
				//       confirmButtonText: '确认放行',
				//       cancelButtonText: '取消',
				//       type: 'warning',
				//     })
				const amountsPayable = info.ymOrder.amountsPayable;
				const discountedPrice = info?.discountedPrice
				var stringText = ''
				if (discountedPrice) {
					stringText = `<strong style='font-size:25px'>${info.numberPlate}出场收费<i style='color:red;'>${amountsPayable}</i>元； 优惠<i style='color:red;'>${discountedPrice}</i>元；总收<i style='color:red;'>${amountsPayable - discountedPrice}</i>元</strong>； `
				} else {
					stringText = `<strong style='font-size:25px'>${info.numberPlate}出场收费<i style='color:red;'>${amountsPayable}</i>元</strong> `
				}
				ElMessageBox.alert(stringText, "收费提示", {
					dangerouslyUseHTMLString: true,
					confirmButtonText: "确认放行",
					cancelButtonText: "取消",
					showCancelButton: true,
					type: "warning",
				}).then(async () => {
					const res = await oneClickRelease({
						deductionAmount: discountedPrice || 0,
						useLogId: info.id,
						openDoor: 1,
						reason: '人工现金收费放行',
						releaseType: 2,
						direction: 1  //0-入场/1-出场
						// couponId: cfCouponList.length > 0 ? cfCouponList[0].id : "",
					});
					if (res.code === 10002) {
						this.$message({message: res.message, type: "success"});
						this.list = this.list.filter((i) => i.ymOrder.id !== info.ymOrder.id);
						localStorage.setItem("ChargeLocalList", JSON.stringify(this.list));
						this.tabIndex = 0;
						// 更新顶部今日现金收费
						this.$emit("countPayAmountByDuty");
					} else {
						this.$message.error(res.message);
					}
				}).catch((err) => console.log(err));
			} else if (type === "abnormal") {
				// 异常放行
				var {message} = await oneClickRelease({
					useLogId: info.id,
					openDoor: 1,
					reason: this.reason[this.reasonIndex],
					releaseType: 5,
					direction: 1  //0-入场/1-出场
				});
				this.$message({message, type: "success",});
				this.list = this.list.filter((i) => i.id !== info.id);
				localStorage.setItem("ChargeLocalList", JSON.stringify(this.list));
				this.tabIndex = 0;
				this.openDoorDialogVisible = false;
			}
		},
		//入口未放行 手动放行
		openDoorManual() {
			const {tabIndex0, showList0} = this;
			const info = showList0[tabIndex0];
			ElMessageBox.confirm(`确定放行${info.numberPlate}吗？`, "提示", {
				confirmButtonText: "确认", cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				const remark = `${showList0[tabIndex0]}；${this.remark}`;
				enterCarRemark({useLogId: info.id, remark});
				oneClickRelease({
					deductionAmount: 0,
					useLogId: info.id,
					openDoor: 1,
					reason: remark,
					releaseType: 2,
					direction: 0
				}).then(() => {
					this.$message({message: '操作成功', type: "success"});
					this.list0 = this.list0.filter(v => v.id !== info.id);
					localStorage.setItem("notEnteredList", JSON.stringify(this.list0));
					this.tabIndex0 = 0;
				}).catch(err => {
					this.$message.error(err.message || '操作失败');
				});
			}).catch(() => {
			});
		}
	},
};
</script>
<style scoped>
.box {
	display: flex;
	height: 50%;
	overflow-y: auto;
}

.box .box-right {
	width: 74%;
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow: auto
}

.reasonBox {
	width: 90px;
	height: 36px;
	background: #efefef;
	border-radius: 3px;
	font-size: 12px;
	font-family: PingFangSC-Medium, PingFang SC, serif;
	font-weight: 500;
	color: #323233;
	line-height: 36px;
	margin-bottom: 16px;
	/* margin-right: 20px; */
	text-align: center;
}

.reasonBox_ac {
	width: 90px;
	height: 36px;
	background: #fc4408;
	border-radius: 3px;
	font-size: 12px;
	font-family: PingFangSC-Medium, PingFang SC, serif;
	font-weight: 500;
	color: #ffffff;
	line-height: 36px;
	margin-bottom: 16px;
	/* margin-right: 20px; */
	text-align: center;
}

.Box {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}

.tabItem {
	min-width: 60px;
	overflow-wrap: break-word;
	color: rgba(255, 255, 255, 1);
	font-size: 12px;
	font-family: PingFangSC-Medium, sans-serif;
	white-space: nowrap;
}

.scroll {
	overflow-y: auto;
	height: calc(100% - 30px);
	min-height: 200px;
}

.scroll > div {
	cursor: pointer;
}

.infoIn {
	display: flex;
	flex-flow: row wrap;
	gap: 10px;
	padding: 0 10px;
	margin: 20px 0;
}
</style>
